/* eslint-disable */
/**
 * Common validation utility functions
 * Shared across Secondary Criteria and Remove Secondary Criteria validations
 */

import {
  InputValidator,
  DateTransformer,
  TextTransformer,
  CommentAppender
} from './validationTypes';

/**
 * Helper function to check if input is valid (not undefined, null, or empty string)
 */
export const isValidInput: InputValidator = (input: any): boolean => {
  return input != undefined && input.toString().trim() != '';
};

/**
 * Helper function to check if input is not valid (undefined, null, or empty string)
 */
export const isNotValidInput: InputValidator = (input: any): boolean => {
  return input == undefined || input.toString().trim() == '';
};

/**
 * Transform Excel serial date to JavaScript Date object
 * Excel stores dates as numbers (days since 1900-01-01)
 * The decimal part represents the time component
 */
export const tranformDate: DateTransformer = (date: any): Date => {
  // Excel serial date conversion: days since 1900-01-01
  // Subtract 25569 (25567 + 2 for Excel's leap year bug)
  // The decimal part represents the time component (if any)
  const exceldate = new Date(((date - (25567 + 2)) * 86400 * 1000));
  const result = new Date(exceldate.toISOString().slice(0, -1));
  return result;
}

/**
 * Transform text to lowercase and remove spaces for comparison
 */
export const transformText: TextTransformer = (input: any): string => {
  return (input)?.toString()?.replace(/\s+/g, '').trim()?.toLowerCase();
};

/**
 * Append validation comment to existing comment
 */
export const appendComment: CommentAppender = (existing: string | undefined, newComment: string): string => {
  return existing ? `${existing}, ${newComment}` : newComment;
};
